/**
 * Elements the widget treats as a **scope root** — one whose own child templates and
 * styles apply to that instance, not the whole page. Both embedding surfaces qualify:
 *  - `[data-lastbot]` — the declarative embedded container;
 *  - `<lastbot-chat>` — the custom element itself (overlay or hand-authored inline).
 * This makes `<template>`/`<style>` blocks copy-pasteable between the two surfaces.
 *
 * Kept in this dependency-free leaf module so both the templating and styling layers can
 * share it without the styling layer importing the templating parser.
 */
export const SCOPE_ROOT_SELECTOR = "[data-lastbot], lastbot-chat";
